import { render } from "./OnibiPage.vue?vue&type=template&id=414facc8&scoped=true"
import script from "./OnibiPage.vue?vue&type=script&lang=js"
export * from "./OnibiPage.vue?vue&type=script&lang=js"

import "./OnibiPage.vue?vue&type=style&index=0&id=414facc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-414facc8"]])

export default __exports__